import jwt_decode from 'jwt-decode';
/**
 * Gets number of milliseconds left for JWT before it's expired
 * @param token JWT to calculate milliseconds
 * @returns Number of milliseconds before JWT is expired
 */
export var getTokenMillisecondsLeft = function (token) {
    var tokenPayload = jwt_decode(token);
    var tokenExpiration = new Date(0).setUTCSeconds(tokenPayload.exp || 0);
    return tokenExpiration - Date.now();
};
